import { AppRouteContextProvider } from '@faro/app-context';
import { FaroToastContainer } from '@faro/design-system';
import { MantineProvider } from '@mantine/core';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import React from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import 'regenerator-runtime/runtime';
import { AppContextProvider } from './AppContextProvider';
import { AppQueryClientProvider } from './AppQueryClientProvider';
import { ErrorBoundary } from './component/ErrorBoundary/ErrorBoundary';
import TooltipPlugin from './component/TooltipPlugin/TooltipPlugin';
import { ConsoleLaunchedReactQueryDevtools } from './package/react-query';
import routes from './routes';
import { ServiceContextProvider } from './service';
import { getBaseUrl } from './util/getBaseUrl';

const baseUrl = getBaseUrl();
axios.defaults.baseURL = baseUrl;
axiosRetry(axios, { retries: 0 });

function App(): React.JSX.Element {
    const router = createBrowserRouter(routes, {
        basename: baseUrl,
    });

    return (
        <ErrorBoundary>
            <MantineProvider>
                <AppRouteContextProvider value={{ routes: router.routes }}>
                    <AppContextProvider>
                        <ServiceContextProvider>
                            <AppQueryClientProvider>
                                <RouterProvider router={router} />
                                <FaroToastContainer />
                                <TooltipPlugin />
                                <ConsoleLaunchedReactQueryDevtools />
                            </AppQueryClientProvider>
                        </ServiceContextProvider>
                    </AppContextProvider>
                </AppRouteContextProvider>
            </MantineProvider>
        </ErrorBoundary>
    );
}

export default App;
